@import '../../../../global/global.pcss';

:host {
  display: inline-flex;
  place-items: center;
  height: var(--row-height, auto);
  word-break: break-word;
}
